export default "__VITE_ASSET__BdzvG5h$__"